/* tslint:disable */
/* eslint-disable */
/**
 * Autom8.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {exists} from '../runtime';

/**
 *
 * @export
 * @interface WorkflowDataInsertDto
 */
export interface WorkflowDataInsertDto {
    /**
     *
     * @type {string}
     * @memberof WorkflowDataInsertDto
     */
    workflowId?: string;
    /**
     *
     * @type {string}
     * @memberof WorkflowDataInsertDto
     */
    key?: string | null;
    /**
     *
     * @type {string}
     * @memberof WorkflowDataInsertDto
     */
    value?: string | null;
}

export function WorkflowDataInsertDtoFromJSON(json: any): WorkflowDataInsertDto {
    return WorkflowDataInsertDtoFromJSONTyped(json, false);
}

export function WorkflowDataInsertDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkflowDataInsertDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'workflowId': !exists(json, 'workflowId') ? undefined : json['workflowId'],
        'key': !exists(json, 'key') ? undefined : json['key'],
        'value': !exists(json, 'value') ? undefined : json['value'],
    };
}

export function WorkflowDataInsertDtoToJSON(value?: WorkflowDataInsertDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'workflowId': value.workflowId,
        'key': value.key,
        'value': value.value,
    };
}

